import React, { Component } from "react";
import moment from 'moment';
import _ from 'lodash';
import SlidingPane from 'react-sliding-pane';
import Avatar from 'react-avatar';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import CamelVoted from "../../assets/images/icon-camel-filled.svg";
import CamelDevoted from "../../assets/images/icon-camel-outline.svg";
import CreateWish from "./CreateWish";
import "./WishListBox.scss";
import { addEventNameToEndpoint } from "../../utils/common";

const sortDesc = (a, b) => {
  if (a.createdAt < b.createdAt) return 1;
  else if (a.createdAt === b.createdAt) return 0;
  else return -1;
}

class WishListBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expandedWish: null,
      isPaneOpen: false,
      editWish: null
    }
  }

  render() {
    const isAdmin = _.get(this.props, "cognitoUser.attributes['custom:role']", '') === 'admin';
    const userId = _.get(this.props, "cognitoUser.username", '');

    return (
      <div className="wishlist-box-container">
        <div className="scroll-area">
          {
            this.props.wishs.sort(sortDesc).map((wish, idx) => {
              const time = moment(wish.createdAt).fromNow();
              const isExpanded = wish.id === this.state.expandedWish;
              const isCreator = wish.requestedBy === userId;
              const hasVoted = wish.upvotedBy && (wish.upvotedBy.find(ub => ub.upvotedBy === userId) || wish.upvotedBy.includes(userId));

              return (
                <div key={idx} className="wish-item">
                  <div className="d-flex justify-content-between event-header">
                    <div className="d-flex align-items-center">
                      <Avatar
                        name={wish.requestedByName}
                        size={31}
                        round={true}
                        color="white"
                        fgColor="pink"
                        src={wish.requestedByAvatar.medium}
                        className="mr-1 wish-avatar"
                      />
                      <span className="event-title">{wish.requestedByName}</span>
                    </div>
                    <div className="wish-status">{wish.status.toUpperCase()}</div>
                  </div>
                  <p className="description">Wishes for a {wish.contentType}, "{wish.title}"</p>
                  {isExpanded &&
                    <div>
                      <div className="wish-more-details">
                        <div className="description-block">
                          <p className="title">because:</p>
                          <p className="description">{wish.why}</p>
                        </div>
                      </div>
                      <div className="wish-more-details">
                        <div className="description-block">
                          <p className="title">highlights:</p>
                          <p className="description">{wish.description}</p>
                        </div>
                      </div>
                      <div className="wish-more-details">
                        <div className="description-block">
                          <p><span className="title mr-1">impact:</span><span>{wish.revenueImpact || 'TBD'}</span></p>
                        </div>
                      </div>
                    </div>
                  }
                  <div className="d-flex justify-content-between">
                    <div className="d-flex">
                      <img
                        src={hasVoted ? CamelVoted : CamelDevoted}
                        className="mr-2 camel-voted"
                        alt="camel"
                        onClick={() => {
                          hasVoted ? this.props.deleteUpvoteWish(wish.id) : this.props.addUpvoteWish(wish.id);
                          addEventNameToEndpoint(this.props.Analytics, hasVoted ? 'user-wishlistItem-unupvote' : 'user-wishlistItem-upvote');
                        }}
                        data-cc-analytics-on='click'
                        id={hasVoted ? 'btnWishlistItemUnupvote' : 'btnWishlistItemUpvote'}
                        data-cc-analytics-name={hasVoted ? 'user-wishlistItem-unupvote' : 'user-wishlistItem-upvote'}
                        data-cc-analytics-attrs={`id:${wish.id},name:${wish.title},userId:${userId}`}
                      />
                      <span>{wish.upvoteCount}</span>
                    </div>
                    {!isCreator && !isExpanded && <a className="item-link" onClick={() => this.setState({ expandedWish: wish.id })}>SEE MORE</a>}
                    {!isCreator && isExpanded && isAdmin && <a className="item-link" onClick={() => this.setState({ expandedWish: null })}>CLOSE</a>}
                    {isCreator && <a className="item-link" onClick={() => this.setState({ isPaneOpen: true, editWish: wish })}>EDIT</a>}
                  </div>
                  <p className="text-right time">{time}</p>
                </div>
              )
            })
          }
          {this.props.wishs.length < 4 && <div className="add-wish-item" onClick={() => this.setState({ isPaneOpen: true })}>+</div>}
        </div>
        {this.props.wishs.length >= 4 && <div className="add-wish-item-anchor" onClick={() => this.setState({ isPaneOpen: true })}>+</div>}
        <SlidingPane
          className='sliding-pane'
          isOpen={this.state.isPaneOpen}
          title="MAKE A WISH"
          subtitle='Create a wish with details'
          onRequestClose={() => { this.setState({ isPaneOpen: false, editWish: null }) }}
        >
          <CreateWish
            onClose={() => this.setState({ isPaneOpen: false, editWish: null })}
            contentTypes={this.props.contentTypes}
            addWish={this.props.addWish}
            editWish={this.state.editWish}
            updateWish={this.props.updateWish}
            deleteWish={this.props.deleteWish}
            wishlistUrgency={this.props.wishlistUrgency}
            Analytics={this.props.Analytics}
          />
        </SlidingPane>
      </div>
    );
  }
}

export default WishListBox;
